import FooterFixedContainer from "../../Componant/PageLayout/FooterFixed";

const FooterFixed = () => {
  return (
    <div className="page-body">
      <FooterFixedContainer />
    </div>
  );
};

export default FooterFixed;
